/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

const Toast = ({ message, type, duration = 5000, onClose }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => prev - (100 / (duration / 100)));
    }, 100);

    const timeout = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [duration, onClose]);

  return (
    <div className={`fixed bottom-4 right-4 w-64 p-4 mb-4 text-sm text-white ${type === "success" ? "bg-green-500" : "bg-red-500"} rounded-lg shadow-lg z-50`} data-testid={`toast-${type}`}>
      <p>{message}</p>
      <div className="h-1 mt-2 bg-white relative overflow-hidden rounded">
        <div
          className="absolute top-0 left-0 h-full bg-gray-700"
          style={{ width: `${progress}%`, transition: "width 0.1s linear" }}
        ></div>
      </div>
    </div>
  );
};

export default Toast;
